<ng-container [formGroup]="form">
	<div class="flex flex-col items-stretch p-fluid space-y-1">
		<label
			[translate]="'presentation.app.common.dialog.coacheeMood.mood.label'"
			for="mood"
		></label>
		<p-selectButton
			[options]="moodOptions"
			formControlName="mood"
			id="mood"
			styleClass="flex items-center p-buttonset-large"
		></p-selectButton>
	</div>
	<div class="flex flex-col items-stretch space-y-1">
		<label
			[translate]="'presentation.app.common.dialog.coacheeMood.feelings.label'"
			for="feelings"
		></label>
		<textarea
			[placeholder]="
				'presentation.app.common.dialog.coacheeMood.feelings.placeHolder'
					| translate
			"
			[rows]="5"
			formControlName="feelings"
			id="feelings"
			pInputTextarea
		></textarea>
	</div>
	<div class="flex flex-col items-stretch space-y-1">
		<label
			[translate]="'presentation.app.common.dialog.coacheeMood.frequency.label'"
			for="frequency"
		></label>
		<p-dropdown
			[options]="frequencyOptions$ | async"
			[placeholder]="
				'presentation.app.common.dialog.coacheeMood.frequency.placeHolder'
					| translate
			"
			[style]="{ width: '100%', maxWidth: '100%' }"
			appendTo="body"
			formControlName="frequency"
			id="frequency"
		></p-dropdown>
	</div>
	<button
		[disabled]="!(formValid$ | async)"
		[label]="'presentation.app.common.dialog.coacheeMood.save.label' | translate"
		(click)="onSaveClick()"
		pButton
	></button>
</ng-container>
